import { Space } from 'component/Space/Space'
import { observer } from 'mobx-react-lite'
import { BuyCard } from 'page/tryon/BuyPane/BuyCard'
import { store } from 'page/tryon/store/TryOnPageStore'

export const BuyPane = observer(() => {
  const { items } = store.it.inference

  return <Space gap={16} top>
    {items.map((item, i) => <BuyCard key={i} item={item} />)}
  </Space>
})
